import * as TWEEN from '@tweenjs/tween.js'
import { Color } from 'three'

import { Material } from '../components/SelectColor'

export type TColorOption = { color: Color }

export function animateChangeMaterials(
  materials: Material[],
  current: TColorOption,
  target: TColorOption,
) {
  const tween = new TWEEN.Tween(current)
    .to(target, 600)
    .easing(TWEEN.Easing.Sinusoidal.Out)
    .onUpdate((option) => {
      for (const material of materials) {
        material.color.set(option.color)
      }
    })
    .start()

  return tween
}
